module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/6965009a8882f6125eba3f100cc81397.png";